import React, { memo } from 'react'
import { HStack } from '../../../../../../ui/Stack'
import cls from './activity-timeline-space.module.css'
import { classNames } from '../../../../../../lib/classNames/classNames'

interface ActivityTimelineSpaceProps {
  className?: string
  text?: string
}

function ActivityTimelineSpace({ className, text }: ActivityTimelineSpaceProps) {
  return (
    <HStack justify="center" align="start">
      <div className={classNames(cls.line, {}, [className])} />
      <div className={cls.titleWrapper}>
        <span>{text}</span>
      </div>
    </HStack>
  )
}

ActivityTimelineSpace.displayName = 'ActivityTimelineSpace'
export default memo(ActivityTimelineSpace)
